module.exports = __webpack_public_path__ + "img/2.c1bf32a5.jpg";